
/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  
    ROW_PER_PAGE : [10, 50, 100, 300, 500],

    // Status
    STATUS_REGISTER:'Register',

    /* Routers Link supplier_app */
    APP_HOME: '/applications',
    HOME: '/home',
    
    HOME_INTRO:'/ap-intro',
    DASHBOARD: '/ap-dashboard',
    INBOX: '/ap-inbox',
    OUTBOX: '/ap-outbox',

   /* Master */







})  

